import React, { useEffect } from 'react';
import axios from 'axios';

const Final = ({ data, result }) => {

  useEffect(() => {
    console.log("Final", data, result, result.user);
  }, []);

  const openPage = () => {

    let userData = result.user; 
    let formData = new FormData();
    formData.append('name', userData.name)
    formData.append('company', userData.company)
    formData.append('email', userData.email)

    axios({
      method: 'POST',
      url: 'indexT.php',
      config: { headers: {'Content-Type': 'multipart/form-data' }},
      data: formData
    }).then(result => {
      console.log('result send', result );
    }).catch(error => console.error('error', error ) );

    window.open("https://www.turvatikas.fi/sertifikaattikoe","_self");
  };

  const batStyle = {
    width: "auto"
  };

  return (
    <div className="final-wrapper">
      <h1 className="titile-step">
        { data && data.final.title }
      </h1>
      <h2 className="step-number">{ data && data.final.paragraph }</h2>
      <div className="final-info">
      { data && data.final.info }
      </div>
      <div className="line"></div>
      <div className="btn-wrapper" style={batStyle}>
        <div className="btn" onClick={openPage}>{ data && data.final.button }</div>
      </div>
    </div>
  );
};

export default Final;
